// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__K1T_C","label":"Labeled_label__1lAFB","divider":"Labeled_divider__3Pzjs"};